<template>
  <div class="user-box flex items-center">
    <el-dropdown trigger="click" @command="onClickItem">
      <div class="flex items-center">
        <CustomIcon :font-size="24" class="mr-2 text-white" name="user" />
        <span class="text-md mt-0.5 mr-2 font-CS font-normal leading-4 text-white">
          {{ currentName }}
        </span>
        <CustomIcon :font-size="16" name="arrow-down" class="text-white" />
      </div>
      <template #dropdown>
        <el-dropdown-menu v-if="!store.isProductionMode">
          <!-- 开发环境-->
          <template v-for="(item, index) in allRoles" :key="index">
            <template v-if="item.name === DIVIDER">
              <div class="my-2 border-b border-solid border-gray-200"></div>
            </template>
            <template v-else>
              <el-dropdown-item
                :class="{ 'justify-end': item.name === LOG_OFF_ITEM.name }"
                :command="item"
              >
                <span :class="{ 'text-primary-blue': currentName === item.name }">
                  <span class="mr-1 font-bold">[{{ item.role }}]</span>
                  {{ item.isS8 ? t(item.name) : item.name }}
                </span>
              </el-dropdown-item>
            </template>
          </template>
        </el-dropdown-menu>
        <!-- 生产环境-->
        <el-dropdown-menu v-else>
          <!-- <div class="my-2 border-b border-solid border-gray-200"></div> -->
          <el-dropdown-item :command="LOG_OFF_ITEM" class="justify-end">
            <span>{{ t('button.logout') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script lang="ts" setup>
import qs from 'qs'

import { paths } from '@/router/paths'
import CustomIcon from '@/components/CustomIcon.vue'
import { useCommonStore } from '@/store/useCommonStore'
import { LOCALSTORAGE_KEYS } from '@/static/enums'

const { t } = useI18n()

const DIVIDER = 'DIVIDER'

type RoleItem = {
  name: string
  role?: string
}

const LOG_OFF_ITEM = {
  name: 'button.logout',
  role: 'Exit',
  isS8: true,
}

const store = useCommonStore()
// TODO... 约束 userInfo 类型
const currentName = computed(() => (store.userInfo as any).userNameEn)

const allRoles: RoleItem[] = [
  {
    name: 'Local development',
    role: 'developer',
  },
  { name: DIVIDER },
  LOG_OFF_ITEM,
]

const onClickItem = (data: RoleItem) => {
  if (data.name === LOG_OFF_ITEM.name) {
    store.logout()
  } else {
    const queries = {
      // org: store.org,
      // role: store.role,
      token: localStorage.getItem(LOCALSTORAGE_KEYS.TOKEN),
      // system: store.system,
    }
    window.location.href = `http://localhost:${import.meta.env.VITE_PORT}/#${
      paths.redirect4login
    }?${qs.stringify(queries)}`
  }
}
</script>

<style lang="scss" scoped>
.user-box {
  margin-right: -4px;
  @apply p-1;
  @apply rounded;
  @apply cursor-pointer;
  @apply hover:bg-[#22373f];
}
</style>
